import { render, staticRenderFns } from "./ChangeContent.vue?vue&type=template&id=4859e306&scoped=true"
import script from "./ChangeContent.vue?vue&type=script&lang=js"
export * from "./ChangeContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4859e306",
  null
  
)

export default component.exports